/**
 * LINE Binding API Service
 */
import apiClient from '../axios.js';

export default {
  /**
   * 查詢綁定記錄列表
   * @param {Object} params - 查詢參數
   * @returns {Promise}
   */
  async list(params = {}) {
    const response = await apiClient.get('/line/binding', { params });
    return response;
  },

  /**
   * 查詢綁定記錄詳情
   * @param {string} id - 綁定記錄 ID
   * @returns {Promise}
   */
  async get(id) {
    const response = await apiClient.get(`/line/binding/${id}`);
    return response;
  },

  /**
   * 查詢綁定統計資訊
   * @param {Object} params - 選填，如 lineConfigId 篩選指定官方帳號
   * @returns {Promise}
   */
  async getStatistics(params = {}) {
    const response = await apiClient.get('/line/binding/statistics', { params });
    return response;
  },

  /**
   * 手動刷新好友 Profile（顯示名稱和頭像）
   * @param {string} id - 綁定記錄 ID
   * @returns {Promise}
   */
  async refreshProfile(id) {
    const response = await apiClient.post(`/line/binding/${id}/refresh-profile`);
    return response;
  },

  /**
   * 查詢好友標籤列表
   * @param {string} id - 綁定記錄 ID
   * @returns {Promise}
   */
  async getTags(id) {
    const response = await apiClient.get(`/line/binding/${id}/tags`);
    return response;
  },

  /**
   * 新增標籤到好友
   * @param {string} id - 綁定記錄 ID
   * @param {string} tagId - 標籤 ID
   * @returns {Promise}
   */
  async addTag(id, tagId) {
    const response = await apiClient.post(`/line/binding/${id}/tags`, { tagId });
    return response;
  },

  /**
   * 移除好友標籤
   * @param {string} id - 綁定記錄 ID
   * @param {string} tagId - 標籤 ID
   * @returns {Promise}
   */
  async removeTag(id, tagId) {
    const response = await apiClient.delete(`/line/binding/${id}/tags/${tagId}`);
    return response;
  },

  /**
   * 刪除好友綁定紀錄（line_follow）
   * @param {string} id - 綁定記錄 ID
   * @returns {Promise}
   */
  async remove(id) {
    const response = await apiClient.delete(`/line/binding/${id}`);
    return response;
  },

  /**
   * 從 LINE 官方帳號建立非同步同步任務
   * @param {string} lineConfigId - LINE 官方帳號設定 ID
   * @returns {Promise}
   */
  async syncFromLine(lineConfigId) {
    const response = await apiClient.post('/line/binding/sync-from-line', { lineConfigId }, {
      timeout: 15000,
      validateStatus: (status) => status >= 200 && status < 300
    });
    return response;
  },

  /**
   * 查詢同步任務狀態
   * @param {string} jobId
   * @returns {Promise}
   */
  async getSyncJob(jobId) {
    const response = await apiClient.get(`/line/binding/sync-jobs/${jobId}`);
    return response;
  },

  /**
   * 查詢進行中的同步任務
   * @param {string} lineConfigId
   * @returns {Promise}
   */
  async getActiveSyncJob(lineConfigId) {
    const response = await apiClient.get('/line/binding/sync-jobs/active', {
      params: { lineConfigId }
    });
    return response;
  },

  /**
   * 重試失敗的同步任務
   * @param {string} jobId
   * @returns {Promise}
   */
  async retrySyncJob(jobId) {
    const response = await apiClient.post(`/line/binding/sync-jobs/${jobId}/retry`, {}, {
      timeout: 15000,
      validateStatus: (status) => status >= 200 && status < 300
    });
    return response;
  },

  /**
   * 匯入舊好友清單
   * @param {string} lineConfigId - LINE 官方帳號設定 ID
   * @param {Array<{lineUserId: string, memberCode?: string}>} items
   * @returns {Promise}
   */
  async importFollowers(lineConfigId, items) {
    const response = await apiClient.post('/line/binding/import', { lineConfigId, items });
    return response;
  }
};
